import { render, staticRenderFns } from "./RecommendCoach.vue?vue&type=template&id=98181516&scoped=true&"
import script from "./RecommendCoach.vue?vue&type=script&lang=js&"
export * from "./RecommendCoach.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCoach.vue?vue&type=style&index=0&id=98181516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98181516",
  null
  
)

export default component.exports